<ng-container
  *appLet="{
   cultures: cultures$ | async,
   feature633IsOn: gbs.growthBook.isOn(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER),
   feature633StringValue: gbs.growthBook.getFeatureValue(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER, ''),
  } as $comp">
  @if ($comp.cultures?.length) {
    <div class="dropdown cultures">
      <button
        class="btn btn-sm btn-navlink text-white toggle-container px-0 border-0 mb-0"
        type="button"
        id="cultureCollapse"
        role="button"
        [ngClass]="{
                    collapsed: collapseCultures,
                    'hoverable-scale': $comp.feature633IsOn && $comp.feature633StringValue !== 'a',
                  }"
        [attr.aria-expanded]="!collapseCultures"
        aria-controls="cultures-dropdown"
        (click)="collapseCultures = !collapseCultures"
        (clickOutside)="collapseCultures = true"
      >
        <div class="d-flex align-items-center gap-1">
          <div class="round-icon__container">
            <img
              class="round-icon"
              *ngIf="
                          cultureCode
                            | culture: CulturePipeTransformType.CountryCode
                            | lowercase
                        "
              src="https://assets.flynorse.com/static/site/flags/{{
                          cultureCode
                            | culture: CulturePipeTransformType.CountryCode
                            | lowercase
                        }}.svg"
              alt="{{ cultureName }} Flag"
            />
          </div>
          @if ($comp.feature633IsOn && $comp.feature633StringValue === 'a') {
            <span class="d-flex align-items-center icon-gap">
                        <div>
                          {{ cultureCode | culture: CulturePipeTransformType.LanguageCode | uppercase }}
                        </div>
                      </span>
            <i class="toggle-chevron mx-0"></i>
          }
        </div>
      </button>
      <ul
        class="dropdown-menu"
        id="cultures-dropdown"
        aria-labelledby="navbarDropdown2"
        [collapse]="collapseCultures"
        [isAnimated]="false"
        [ngClass]="{
        'dropdown-container': $comp.feature633IsOn && $comp.feature633StringValue !== 'a',
        'dropdown-menu--left': alignToLeft
        }"
      >
        @for (culture of cultures($comp.cultures); track $index) {

          <li
            (mousedown)="
                        changeCulture(culture.cultureCode, cultureCode)
                      "
            [ngClass]="{'lang-item': $comp.feature633IsOn && $comp.feature633StringValue !== 'a'}"
          >
            @if ($comp.feature633IsOn && $comp.feature633StringValue !== 'a') {
              <div class="lang-item-content">
                <div class="round-icon__container round-icon__container--small">
                  <img
                    class="round-icon"
                    *ngIf="
                                culture.cultureCode
                                  | culture: CulturePipeTransformType.CountryCode
                                  | lowercase
                              "
                    src="https://assets.flynorse.com/static/site/flags/{{
                                culture.cultureCode
                                  | culture: CulturePipeTransformType.CountryCode
                                  | lowercase
                              }}.svg"
                    alt="{{ culture.name }} Flag"
                  />
                </div>
                <span class="lang-item-content__text">{{ culture.translatedName }}</span>
              </div>
            } @else {
              <div class="d-flex align-items-center gap-1 nav-accordion-item">
                <div class="round-icon__container">
                  <img
                    class="round-icon"
                    *ngIf="
                                culture.cultureCode
                                  | culture: CulturePipeTransformType.CountryCode
                                  | lowercase
                              "
                    src="https://assets.flynorse.com/static/site/flags/{{
                                culture.cultureCode
                                  | culture: CulturePipeTransformType.CountryCode
                                  | lowercase
                              }}.svg"
                    alt="{{ culture.name }} Flag"
                  />
                </div>
                <span>|</span>
                <div>{{ culture.shortName }}</div>
                <div>{{ ' (' + (culture.cultureCode | culture: CulturePipeTransformType.LanguageCode | uppercase) + ')' }}</div>
              </div>
            }
          </li>
        }
      </ul>
    </div>
  }
</ng-container>
